/* MiCuadro - Galeria auto-mockup
   Solo escenas montadas (arte dentro del marco). Sin imagenes crudas.
   - PDP: usa window.MC_MOCKUP + #mc-mockup-gallery (una instancia).
   - Tarjetas de coleccion: usa .mc-card-slot[data-group][data-art]
     con window.MC_CARD_TPLS para las plantillas (multiples instancias). */
(function () {
  function esc(s) { return (s || '').replace(/"/g, '&quot;'); }

  function decodeAttr(s) {
    var t = document.createElement('textarea');
    t.innerHTML = s || '';
    return t.value;
  }

  function compositeHTML(slide, alt) {
    var h = '<div class="mc-cmp"><img class="mc-bg" src="' + slide.src + '" alt="' + esc(alt) + '" loading="lazy">';
    slide.slots.forEach(function (sl, i) {
      var src = slide.imgs[i];
      if (!src) return;
      h += '<img class="mc-art" src="' + src + '" alt="' + esc(alt) + '" loading="lazy" ' +
           'style="left:' + sl[0] + '%;top:' + sl[1] + '%;width:' + sl[2] + '%;height:' + sl[3] + '%">';
    });
    return h + '</div>';
  }

  function buildSlides(tpls, art) {
    var n = art.length;
    var slides = [];
    var singleIdx = 0;
    tpls.forEach(function (t) {
      var imgs = [];
      if (t.slots.length > 1) {
        for (var i = 0; i < t.slots.length; i++) imgs.push(art[i] || art[art.length - 1]);
      } else {
        if (n <= 1) {
          imgs.push(art[0]);
        } else {
          imgs.push(art[singleIdx] || art[art.length - 1]);
          singleIdx++;
        }
      }
      slides.push({ src: t.src, slots: t.slots, imgs: imgs });
    });
    return slides;
  }

  /* ── PDP: galeria con thumbnails ── */
  function build() {
    var cfg = window.MC_MOCKUP;
    var root = document.getElementById('mc-mockup-gallery');
    if (!cfg || !root) return;

    var tpls = (cfg.tpl && cfg.tpl[cfg.group]) || [];
    var slides = buildSlides(tpls, cfg.art || []);
    if (!slides.length) return;

    var main = document.createElement('div'); main.className = 'mc-main';
    var thumbs = document.createElement('div'); thumbs.className = 'mc-thumbs';

    function setActive(idx) {
      main.innerHTML = compositeHTML(slides[idx], cfg.alt);
      var btns = thumbs.querySelectorAll('.mc-thumb');
      for (var i = 0; i < btns.length; i++) btns[i].classList.toggle('is-active', i === idx);
    }

    slides.forEach(function (s, idx) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mc-thumb' + (idx === 0 ? ' is-active' : '');
      b.setAttribute('aria-label', 'Vista ' + (idx + 1));
      b.innerHTML = compositeHTML(s, cfg.alt);
      b.addEventListener('click', function () { setActive(idx); });
      thumbs.appendChild(b);
    });

    root.appendChild(main);
    root.appendChild(thumbs);
    setActive(0);
  }

  /* ── Tarjetas de coleccion: misma logica, sin thumbnails, con hover ── */
  function buildCards() {
    var tplCfg = window.MC_CARD_TPLS;
    if (!tplCfg) return;
    document.querySelectorAll('.mc-card-slot:not([data-built])').forEach(function (el) {
      el.setAttribute('data-built', '1');
      var g   = el.getAttribute('data-group') || 'vertical';
      var alt = el.getAttribute('data-alt')   || '';
      var art = [];
      try { art = JSON.parse(decodeAttr(el.getAttribute('data-art') || '[]')); } catch (e) {}
      var tpls = tplCfg[g] || tplCfg['vertical'] || [];
      /* Solo 2 escenas para la tarjeta: portada + hover */
      var slides = buildSlides(tpls.slice(0, 2), art);
      if (!slides.length) return;
      var html = slides.map(function (s, idx) {
        return '<div class="mc-cs mc-cs-' + (idx + 1) + '">' + compositeHTML(s, alt) + '</div>';
      }).join('');
      el.innerHTML = '<div class="mc-cw">' + html + '</div>';
    });
  }

  function init() {
    build();
    buildCards();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
